import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { distributorService } from '../services/api';

function Distributors() {
  const [distributors, setDistributors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadDistributors();
  }, []);

  const loadDistributors = async () => {
    try {
      const data = await distributorService.index();
      setDistributors(data.data || data || []);
    } catch (error) {
      console.error('Error loading distributors:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="min-h-screen flex items-center justify-center">Loading...</div>;

  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-white shadow">
        <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
          <Link to="/" className="text-xl font-bold text-gray-900">Ortus</Link>
          <div className="flex gap-4">
            <Link to="/shop" className="text-blue-600">Shop</Link>
            <Link to="/login" className="text-blue-600">Login</Link>
          </div>
        </div>
      </nav>

      <main className="max-w-6xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold mb-8">Our Distributors</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {distributors.map((d) => (
            <div key={d.id} className="bg-white p-6 rounded-lg shadow">
              <h3 className="text-lg font-semibold mb-1">{d.company_name}</h3>
              <p className="text-sm text-gray-600 mb-1">{d.contact_name}</p>
              <p className="text-sm text-gray-600 mb-1">{d.email} &middot; {d.phone}</p>
              <p className="text-sm text-gray-600 mb-1">{d.city}, {d.state} {d.country}</p>
              <span className={`inline-flex text-xs leading-5 font-semibold rounded-full px-2 py-1 mt-2 ${d.status === 'approved' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`}>{d.status}</span>
            </div>
          ))}
        </div>
        {distributors.length === 0 && <p className="text-gray-500 mt-4">No distributors listed yet.</p>}
      </main>
    </div>
  );
}

export default Distributors;
